<div class="d-flex justify-content-center">
    <video
        #trainingVideo
        controls
        class="video"
        [ngStyle]="{ visibility: displayPlayer() }"
    ></video>
</div>
